import React from "react";
import "./Footer.css";
import logo3 from "../assets/Logga-vit.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="footerContainer">

        <div className="footer-info">
          <img src={logo3} alt={t("footerLogoAlt")} className="logo3" />

          <p>{t("aboutUsText")}</p>

          <div className="footer-contact-details">
            <p><strong>{t("phone")}:</strong> <a href="tel:+46708240472">+46 708 24 04 72</a></p>
            <p><strong>{t("email")}:</strong> <a href="mailto:peter@dinmaklareahus.se">peter@dinmaklareahus.se</a></p>
            <p><strong>{t("address")}:</strong> {t("addressText")}</p>
          </div>
        </div>

        <div className="footer-links-social">
          <h2>{t("quickLinks")}</h2>
          <ul className="quick-links">
            <li><a href="/">{t("home")}</a></li>
            <li><a href="/alla-fastigheter">{t("ourHomes")}</a></li>
            <li><a href="/buyhome">{t("sellWithUs")}</a></li>
            <li><a href="/soldObjects">{t("soldObjects")}</a></li>
            <li><a href="/contact">{t("contact")}</a></li>
          </ul>

          <h2>{t("socialMedia")}</h2>
          <div className="social-icons">
            <a href="https://www.instagram.com/dinmaklareahus/?__d=1" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a href="https://www.google.com/maps?q=Köpmannagatan+15,+296+31+Åhus" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faLocationDot} />
            </a>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        <p>{t("footerCopyright")}</p>
      </div>
    </footer>
  );
};

export default Footer;
